import "../App.css";
import "./home.css";
import React, { useState, useEffect } from "react";
import { LoadingPage } from "../loading/LoadingPage";
import { NavigationBar } from "../navigation/NavigationBar";

import { useParams, Link } from "react-router-dom";
import { call, home } from "../service/ApiService";
import {
  Container,
  List,
  Paper,
  //Grid,
  // Button,
  // AppBar,
  // Toolbar,
  //Typography,
  ListItem,
  ListItemText,
  InputBase,
  Checkbox,
  ListItemSecondaryAction,
  IconButton,
  Button,
} from "@mui/material";

export function Home() {
  // pays?basket=402880828b0fce5b018b0fcebef80000
  const params = new URLSearchParams(window.location.search);
  let messege = params.get("messege");
  //console.log("basket :" + basket);
  //pays({ basket: basket });

  /* 장애일 때 렌더링 할 부분 */
  //let loadingPage = <h1> admin.. </h1>;
  //let content = todoItems;

  /* 선택한 content 렌더링 */
  //{"welcomt Home!"}

  let home = "Welcome Home!";

  let subject = "Home";
  let navigationBar = NavigationBar(subject);

  //<Checkbox checked={item.done} onChange={checkboxEventHandler} />

  let menu = (
    <Paper style={{ margin: 16 }}>
      <List className="menu">
        <div>{"Menu"}</div>
        <ListItem>
          <Link to="/" variant="2">
            {home} {messege}
          </Link>
          <ListItemText></ListItemText>
          <ListItemSecondaryAction>{"안녕하세요."}</ListItemSecondaryAction>
        </ListItem>
        <ListItem>
          <Link to="/todo" variant="3">
            {"TODO 메모장"}
          </Link>
          <ListItemText></ListItemText>
          <ListItemSecondaryAction>
            {"간단히 작성 가능한 메모장입니다."}
          </ListItemSecondaryAction>
        </ListItem>

        {/*
        <ListItem>
          <Link to="/item" variant="4">
            {"상품 리스트"}
          </Link>
          <ListItemText></ListItemText>
          <ListItemSecondaryAction>
            {"상품 리스트 페이지입니다."}
          </ListItemSecondaryAction>
        </ListItem>

        <ListItem>
          <Link to="/basketList" variant="4">
            {"장바구니 리스트"}
          </Link>
          <ListItemText></ListItemText>
          <ListItemSecondaryAction>
            {"장바구니 리스트 페이지입니다."}
          </ListItemSecondaryAction>
        </ListItem>
        */}

        {/*
        <ListItem>
          <Link to="/api" variant="5">
            {"Api 호출"}
          </Link>
          <ListItemText></ListItemText>
          <ListItemSecondaryAction>
            {"관리자용 Api 페이지 입니다."}
          </ListItemSecondaryAction>
        </ListItem>
        */}

        <ListItem>
          <Link to="/lotto" variant="5">
            {"로또번호 자동생성기 "}
          </Link>
          <ListItemText></ListItemText>
          <ListItemSecondaryAction>
            {"로또번호가 자동생성됩니다."}
          </ListItemSecondaryAction>
        </ListItem>

        {/* 
        <ListItem>
          <Link to="/upbit" variant="5">
            {"외부 API "}
          </Link>
          <ListItemText></ListItemText>
          <ListItemSecondaryAction>
            {"외부API 불러오는 테스트."}
          </ListItemSecondaryAction>
        </ListItem>
        */}
      </List>
    </Paper>
  );

  let content;
  /* 로딩중이 아닐 때 렌더링 할 부분 */
  let framePage = (
    <div>
      {navigationBar} {/* 네비게이션 바 렌더링 */}
      <Container maxWidth="md">{""}</Container>
      <Container maxWidth="md">{menu}</Container>
    </div>
  );

  content = framePage;
  return <div className="App">{content}</div>;
}
